// if theme-ui ever creates motion variants but objects will do for now
// export enum MotionVariants {
//   simpleFade = "simpleFade",
//   enterObject = "enterObject",
// }
// transition properties
export const simpleFadeTransitionProperties = {
    type: "spring",
    stiffness: 400,
    damping: 20
};
export const enterObjectTransitionProperties = {
    type: "spring",
    stiffness: 500,
    damping: 66
};
export const pageTransitionProperties = {
    type: "spring",
    stiffness: 400,
    damping: 66
};
// motion movements
export const simpleFadeMotion = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1,
        transition: simpleFadeTransitionProperties
    },
    exit: {
        opacity: 0,
        transition: simpleFadeTransitionProperties
    }
};
export const enterObjectMotion = {
    initial: {
        y: 66,
        opacity: 0
    },
    animate: {
        y: 0,
        opacity: 1,
        transition: pageTransitionProperties
    },
    exit: {
        y: -66,
        opacity: 0,
        transition: pageTransitionProperties
    }
};
export const modalMotion = {
    initial: {
        y: 66,
        opacity: 0
    },
    animate: {
        y: 0,
        opacity: 1,
        transition: enterObjectTransitionProperties
    },
    exit: {
        y: 66,
        opacity: 0,
        transition: enterObjectTransitionProperties
    }
};
export const overLayMotion = {
    initial: {
        opacity: 0,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "linear-gradient(206.65deg, rgba(5, 30, 52, 0.78) 0%, rgba(5, 30, 52, 0.42) 100%)"
    },
    animate: {
        opacity: 1,
        transition: enterObjectTransitionProperties
    },
    exit: {
        opacity: 0,
        transition: enterObjectTransitionProperties
    }
};
//# sourceMappingURL=motion.js.map